<template>
  <!--定位地图 -->
  <el-dialog title="位置" :visible.sync="isShow" class="dialog-lg dialog-map">
    <baidu-map
      :long="longitude"
      :latx="latitude"
      :location="myAddress"
    ></baidu-map>
  </el-dialog>
</template>

<script>
import { isSuccess } from "@/assets/js/utils";
import BaiduMap from "@/components/map/baidu-map";
export default {
  data() {
    return {
      isShow: false,
      lat: "",
      long: "",
      addre: "",
    };
  },
  created() {},
  computed: {
    latitude: function () {
      return this.lat;
    },
    longitude: function () {
      return this.long;
    },
    myAddress: function () {
      return this.addre;
    },
  },
  components: {
    BaiduMap,
  },
  methods: {
    //打开弹窗
    show(pid) {
      const loading = this.$loading({
        lock: true,
        text: "定位中，请耐心等待",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      api("waybill.position", { id: pid }).then((res) => {
        let data;
        loading.close();
        if ((data = isSuccess(res))) {
          this.isShow = true;
          this.lat = res.data.lat;
          this.long = res.data.lng;
          if (res.data.address) {
            this.addre = res.data.address;
          } else {
            this.addre = "未知";
          }
        } else {
          alert(res.msg);
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
@import "src/assets/sass/mixin";
</style>



// WEBPACK FOOTER //
// src/components/dialog/waybill-position-map.vue